(() => {
  const init = (root) => {
    if (root.dataset.dspInitialized) return;
    root.dataset.dspInitialized = 'true';
    const key = 'pys-dsp-guide-unlocked-v1';
    const panel = root.querySelector('[data-dsp-downloads]');
    const status = root.querySelector('[data-dsp-status]');
    const unlock = (moveFocus = false) => {
      root.dataset.dspUnlocked = 'true';
      root.querySelectorAll('[data-locked-button]').forEach(el => el.hidden = true);
      root.querySelectorAll('[data-dsp-file]').forEach(el => el.hidden = false);
      root.querySelector('[data-lock-icon]').setAttribute('hidden', '');
      root.querySelector('[data-unlocked-icon]').removeAttribute('hidden');
      status.textContent = root.dataset.readyMessage;
      try { sessionStorage.setItem(key, 'true'); } catch {}
      if (moveFocus) {
        panel.querySelector('h2').focus({preventScroll: true});
        panel.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest'});
      }
    };
    root.querySelector('[data-dsp-unlock]').addEventListener('click', () => unlock(true));
    try { if (sessionStorage.getItem(key) === 'true') unlock(); } catch {}
    const signup = root.querySelector('.pys-dsp__signup');
    const signupSuccess = root.querySelector('[data-dsp-signup-success]');
    const returnTo = signup.querySelector('[name="return_to"]');
    const target = new URL('/pages/dsp-guide', location.origin);
    const current = new URL(location.href);
    ['preview_theme_id', 'pb'].forEach(key => { if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key)); });
    target.searchParams.set('customer_posted', 'true');
    target.hash = 'DspDownloads';
    if (returnTo) returnTo.value = target.pathname + target.search + target.hash;
    const pendingKey = 'pys-dsp-newsletter-pending-v1';
    signup.addEventListener('submit', () => {
      if (signup.checkValidity()) {
        try { sessionStorage.setItem(pendingKey, 'true'); } catch {}
      }
    });
    let pending = false;
    try { pending = sessionStorage.getItem(pendingKey) === 'true'; } catch {}
    if (!root.querySelector('[data-dsp-signup-error]') && (!signupSuccess.hidden || (pending && current.searchParams.get('customer_posted') === 'true'))) {
      signupSuccess.hidden = false;
      unlock();
      try { sessionStorage.removeItem(pendingKey); } catch {}
    }
    root.querySelectorAll('[data-dsp-file]').forEach(link => {
      link.addEventListener('click', async event => {
        event.preventDefault();
        if (link.dataset.downloading) return;
        link.dataset.downloading = 'true';
        link.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(link.href);
          if (!response.ok) throw new Error('Download failed');
          const url = URL.createObjectURL(await response.blob());
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = link.getAttribute('download');
          document.body.append(anchor);
          anchor.click();
          anchor.remove();
          setTimeout(() => URL.revokeObjectURL(url), 30000);
        } catch {
          const error = root.querySelector('[data-download-error]');
          error.querySelector('[data-direct-file]').href = link.href;
          error.hidden = false;
        } finally { delete link.dataset.downloading; link.removeAttribute('aria-busy'); }
      });
    });
  };
  const scan = () => document.querySelectorAll('[data-dsp-guide]').forEach(init);
  scan();
  document.addEventListener('DOMContentLoaded', scan, {once:true});
  document.addEventListener('shopify:section:load', scan);
})();
